export default __webpack_public_path__ + "static/media/3_2.6383aa2a.jpg";